var _filter, _filter2, _rect, _circle, _circle2, _circle3, _rect2, _text, _line, _text2, _text3, _text4, _rect3, _rect4, _rect5, _text5, _text6, _rect6, _text7, _text8, _rect7, _text9, _text0, _rect8, _text1, _circle4, _text10, _rect9, _circle5, _text11, _text12, _text13, _text14, _rect0, _circle6, _text15, _text16, _text17, _text18, _rect1, _circle7, _text19, _text20, _text21, _text22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRfid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0f172a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0d1f2d"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "green",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#059669"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#10b981"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1e293b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0f172a"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 8,
    floodColor: "#000",
    floodOpacity: 0.5
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 200,
    r: 180,
    fill: "none",
    stroke: "#10b98108",
    strokeWidth: 60
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 200,
    r: 120,
    fill: "none",
    stroke: "#10b98110",
    strokeWidth: 40
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 200,
    r: 60,
    fill: "none",
    stroke: "#10b98118",
    strokeWidth: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 260,
    height: 150,
    rx: 16,
    fill: "url(#card)",
    filter: "url(#shadow)",
    stroke: "#10b98130",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 60,
    fill: "#10b981",
    fontFamily: "Arial",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 2
  }, "RFID ATTENDANCE")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 70,
    x2: 270,
    y2: 70,
    stroke: "#10b98130",
    strokeWidth: 1
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 95,
    fill: "#94a3b8",
    fontFamily: "Arial",
    fontSize: 11
  }, "Today")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 115,
    fill: "white",
    fontFamily: "Arial",
    fontSize: 22,
    fontWeight: "bold"
  }, "42 Present")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 138,
    fill: "#64748b",
    fontFamily: "Arial",
    fontSize: 11
  }, "out of 50 students")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 152,
    width: 220,
    height: 6,
    rx: 3,
    fill: "#1e293b"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 152,
    width: 185,
    height: 6,
    rx: 3,
    fill: "url(#green)",
    opacity: 0.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 30,
    width: 130,
    height: 68,
    rx: 14,
    fill: "url(#card)",
    filter: "url(#shadow)",
    stroke: "#10b98130",
    strokeWidth: 1
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 328,
    y: 56,
    fill: "#94a3b8",
    fontFamily: "Arial",
    fontSize: 11
  }, "On Time")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 328,
    y: 80,
    fill: "#10b981",
    fontFamily: "Arial",
    fontSize: 20,
    fontWeight: "bold"
  }, "38")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 458,
    y: 30,
    width: 112,
    height: 68,
    rx: 14,
    fill: "url(#card)",
    filter: "url(#shadow)",
    stroke: "#f59e0b30",
    strokeWidth: 1
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 474,
    y: 56,
    fill: "#94a3b8",
    fontFamily: "Arial",
    fontSize: 11
  }, "Late")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 474,
    y: 80,
    fill: "#f59e0b",
    fontFamily: "Arial",
    fontSize: 20,
    fontWeight: "bold"
  }, "4")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 112,
    width: 260,
    height: 68,
    rx: 14,
    fill: "url(#card)",
    filter: "url(#shadow)",
    stroke: "#6366f130",
    strokeWidth: 1
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 328,
    y: 138,
    fill: "#94a3b8",
    fontFamily: "Arial",
    fontSize: 11
  }, "Absent")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 328,
    y: 162,
    fill: "#f87171",
    fontFamily: "Arial",
    fontSize: 20,
    fontWeight: "bold"
  }, "8 students")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 200,
    width: 540,
    height: 170,
    rx: 16,
    fill: "url(#card)",
    filter: "url(#shadow)",
    stroke: "#ffffff08",
    strokeWidth: 1
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 228,
    fill: "white",
    fontFamily: "Arial",
    fontSize: 13,
    fontWeight: "bold"
  }, "Recent Scans")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 220,
    r: 6,
    fill: "#10b981",
    filter: "url(#glow)"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 225,
    fill: "#10b981",
    fontFamily: "Arial",
    fontSize: 9
  }, "LIVE")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 240,
    width: 500,
    height: 1,
    fill: "#ffffff08"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 263,
    r: 10,
    fill: "#10b98120",
    stroke: "#10b98150",
    strokeWidth: 1
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 267,
    fill: "#10b981",
    fontFamily: "Arial",
    fontSize: 9,
    textAnchor: "middle"
  }, "IN")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 261,
    fill: "white",
    fontFamily: "Arial",
    fontSize: 11,
    fontWeight: 600
  }, "Juan dela Cruz")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 275,
    fill: "#64748b",
    fontFamily: "Arial",
    fontSize: 10
  }, "BSCS 3-A  \u2022  08:02 AM")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 510,
    y: 268,
    fill: "#10b981",
    fontFamily: "Arial",
    fontSize: 10,
    fontWeight: 700
  }, "Present")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 288,
    width: 500,
    height: 1,
    fill: "#ffffff08"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 311,
    r: 10,
    fill: "#f59e0b20",
    stroke: "#f59e0b50",
    strokeWidth: 1
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 315,
    fill: "#f59e0b",
    fontFamily: "Arial",
    fontSize: 8,
    textAnchor: "middle"
  }, "IN")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 309,
    fill: "white",
    fontFamily: "Arial",
    fontSize: 11,
    fontWeight: 600
  }, "Maria Santos")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 323,
    fill: "#64748b",
    fontFamily: "Arial",
    fontSize: 10
  }, "BSCS 3-A  \u2022  08:17 AM")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 510,
    y: 316,
    fill: "#f59e0b",
    fontFamily: "Arial",
    fontSize: 10,
    fontWeight: 700
  }, "Late")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 336,
    width: 500,
    height: 1,
    fill: "#ffffff08"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 359,
    r: 10,
    fill: "#10b98120",
    stroke: "#10b98150",
    strokeWidth: 1
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 363,
    fill: "#10b981",
    fontFamily: "Arial",
    fontSize: 9,
    textAnchor: "middle"
  }, "IN")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 357,
    fill: "white",
    fontFamily: "Arial",
    fontSize: 11,
    fontWeight: 600
  }, "Carlos Reyes")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 371,
    fill: "#64748b",
    fontFamily: "Arial",
    fontSize: 10
  }, "BSCS 3-A  \u2022  07:58 AM")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 510,
    y: 364,
    fill: "#10b981",
    fontFamily: "Arial",
    fontSize: 10,
    fontWeight: 700
  }, "Present")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfid);
export default __webpack_public_path__ + "static/media/rfid.d157d645cbff7f324f7f84eeced56626.svg";
export { ForwardRef as ReactComponent };